import React from 'react';

function ContactInformations(props) {    

    return (
        <React.Fragment>
            <div className="border align-items-center p-4">
                <h4>Informations</h4>
                <ul class="contact-info no-margin">
                    <li>
                        <i class="fas fa-map-marker-alt text-theme-color"></i>
                        Boulevard Des Armées Sotuba ACI - Bamako, Mali
                    </li>
                    <li>
                        <i class="fas fa-phone text-theme-color"></i>
                        <a href="tel:+22344905070">+223 44 90 50 70</a> / <a href="tel:+22391252114">+223 91 25 21 14</a>
                    </li>
                    <li>
                        <i class="fas fa-envelope text-theme-color"></i>
                        <a href="mailto:contact@malibaara.com">contact@malibaara.com</a>
                    </li>
                    <li>
                        <i class="fas fa-globe text-theme-color"></i>
                        <a href="https://www.d3kinc.com" target="_blank">www.d3kinc.com</a>
                    </li>
                </ul>
            </div>
        </React.Fragment>
    )
}

export default ContactInformations;